import gql from "graphql-tag";

export const GET_ARTISTS_WITH_AVAILABILITIES = gql`
  query Artists(
    $where: ArtistWhereInput
    $availabilitiesWhere2: ArtistAvailabilityWhereInput
  ) {
    artists(where: $where) {
      id
      user_id
      cover_photo_url
      user {
        id
        first_name
        last_name
        photo_url
        joined_company_id
      }
      availabilities(where: $availabilitiesWhere2) {
        id
        availability {
          id
          start_time
          end_time
          location_id
        }
      }
    }
  }
`;
export const GET_ARTISTS = gql`
  query Artists($where: ArtistWhereInput) {
    artists(where: $where) {
      id
      user_id
      cover_photo_url
      user {
        id
        first_name
        last_name
        photo_url
        joined_company_id
      }
    }
  }
`;
export const FIND_FIRST_USER_BY_PHONE = gql`
  query userByPhoneQuery($where: UserWhereInput) {
    findFirstUser(where: $where) {
      id
      photo_url
      phone_number
      first_name
      last_name
      pronoun
      libphonenumber
    }
  }
`;
export const GET_MENU_SECTION_BY_LOCATION = gql`
  query MenuSections(
    $where: MenuSectionWhereInput
    $orderBy: [MenuSectionOrderByWithRelationInput!]
    $menuSectionServicesOrderBy2: [MenuSectionServiceOrderByWithRelationInput!]
  ) {
    menuSections(where: $where, orderBy: $orderBy) {
      id
      name
      menu_section_services(orderBy: $menuSectionServicesOrderBy2) {
        service {
          id
          description
          duration
          name
          photo_1_url
          photo_2_url
          photo_3_url
          photo_4_url
          photo_5_url
          price
          special_conditions
          category
          add_ons {
            id
            core_service {
              id
              description
              duration
              name
              photo_1_url
              photo_2_url
              photo_3_url
              photo_4_url
              photo_5_url
              price
              special_conditions
              scheduling_priority
              choice_is_required
            }
            add_on {
              id
              description
              duration
              name
              photo_1_url
              photo_2_url
              photo_3_url
              photo_4_url
              photo_5_url
              price
              special_conditions
            }
          }
          core_services {
            id
            core_service {
              id
              description
              duration
              name
              photo_1_url
              photo_2_url
              photo_3_url
              photo_4_url
              photo_5_url
              price
              special_conditions
            }
          }
        }
      }
    }
  }
`;

export const GET_LOCATIONS = gql`
  query Locations($where: LocationWhereInput) {
    locations(where: $where) {
      id
      company_id
      timezone
      menu {
        id
      }
    }
  }
`;

export const GET_APPOINTMENTS = gql`
  query ($where: AppointmentWhereInput) {
    appointments(where: $where) {
      id
      start_time
      end_time
      is_blocked_time
      is_artist_specified
      appointment_services {
        id
        appointment_id
        artist_id
        start_time
        end_time
        person_name
        person_number
        is_blocked_time
        artist {
          id
          cover_photo_url
          user {
            id
            first_name
            last_name
            photo_url
          }
        }
        user {
          id
          first_name
          last_name
          photo_url
          phone_number
        }
        appointment {
          id
          full_amount
          location {
            id
            name
            nickname
            timezone
          }
          notes
          is_artist_specified
        }
        service {
          id
          name
          price
          duration
        }
        add_ons {
          id
          service_id
          add_on_service_id
          core_service {
            id
            name
            price
            category
          }
        }
      }
    }
  }
`;
export const GET_APPOINTMENT_SERVICES = gql`
  query AppointmentServices($where: AppointmentServiceWhereInput) {
    appointmentServices(where: $where) {
      id
      appointment_id
      artist_id
      start_time
      end_time
      person_name
      person_number
      is_blocked_time
      artist {
        id
        cover_photo_url
        user {
          id
          first_name
          last_name
          photo_url
        }
      }
      user {
        id
        first_name
        last_name
        photo_url
        phone_number
      }
      appointment {
        id
        full_amount
        location {
          id
          name
          nickname
          timezone
        }
        notes
      }
      service {
        id
        name
        price
        duration
      }
      add_ons {
        id
        service_id
        add_on_service_id
        core_service {
          id
          name
          price
          category
        }
      }
    }
  }
`;

export const GET_USER_USING_ORDER = gql`
  query Order($where: OrderWhereUniqueInput!, $refundWhere: RefundWhereInput) {
    order(where: $where) {
      id
      user {
        id
        first_name
        last_name
        phone_number
        Refund(where: $refundWhere) {
          id
          amount
          consumed
        }
        StripePaymentMethods {
          id
          brand
          stripe_id
          last4
          is_default
          exp_month
          exp_year
        }
      }
    }
  }
`;

export const GET_USER = gql`
  query User($where: UserWhereUniqueInput!) {
    user(where: $where) {
      id
      email
      phone_number
      first_name
      last_name
      photo_url
      StripePaymentMethods {
        id
        brand
        last4
        is_default
        exp_month
        exp_year
      }
      company_descriptions {
        id
        description
        user_id
        company_id
      }
      reminder_settings {
        id
        type
        value
        enabled
      }
    }
  }
`;

export const GET_COMPANY_PAYMENT_METHOD = gql`
  query Company($where: CompanyWhereUniqueInput!) {
    company(where: $where) {
      id
      name
      is_verified
      status
      upgrade_trial_granted_at
      owner {
        id
        email
        phone_number
      }
      StripePaymentMethods {
        id
        brand
        last4
        is_default
        exp_month
        exp_year
      }
    }
  }
`;

export const GET_SORTED_MENU = gql`
  query Menu(
    $where: MenuWhereUniqueInput!
    $orderBy: [MenuSectionOrderByWithRelationInput!]
    $menuSectionServicesOrderBy2: [MenuSectionServiceOrderByWithRelationInput!]
  ) {
    menu(where: $where) {
      id
      name
      company_id
      created_at
      updated_at
      menu_sections(orderBy: $orderBy) {
        id
        name
        section_position
        menu_section_services(orderBy: $menuSectionServicesOrderBy2) {
          id
          section_position
          service {
            id
            duration
            name
            price
          }
          service_id
        }
      }
      company {
        id
      }
      locations {
        id
        company_id
        name
        nickname
        timezone
      }
    }
  }
`;

export const GET_NEXT_FUTURE_APPOINTMENT_SERVICE_ID = gql`
  query NextFutureAppointmentServiceId(
    $where: AppointmentServiceWhereInput
    $take: Int
    $orderBy: [AppointmentServiceOrderByWithRelationInput!]
  ) {
    appointmentServices(where: $where, take: $take, orderBy: $orderBy) {
      id
    }
  }
`;
